<div id="showcase">
  <div class="container">
    <div id="showcaseCarousel" class="carousel slide" data-bs-ride="carousel" >
      <!-- <div class="carousel-indicators">
        <button type="button" data-bs-target="#showcaseCarousel" *ngFor="let img of imgUrl, let i = index" class="{{ (i == 0) ? 'active' : '' }}"  attr.data-bs-slide-to="{{i}}" ></button>
      </div> -->
      <div class="carousel-inner">
        <div class="carousel-item" *ngFor="let img of imgUrl; let i=index" [ngClass]="(i == 0 ) ? 'active' : ''">
          <div class="container-fluid" id="loader" *ngIf="isLoading[i]">
            <app-loader></app-loader>
          </div>
          <img  [src]="img" alt="Slider" class="img-fluid" [ngStyle]="{visibility:isLoading[i]?'hidden':'visible'}"
          (load)="hideLoader(i)" (error)="hideLoader(i)">
        </div>
        
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
    
    
  </div>
</div>